import { ICommercialBreadcrumbs } from 'shared/types/commercialBreadcrumbs';
import { IOffersData } from 'shared/types/offersData';

export interface IPageChangeStartedAction {
  type: 'pagination/PAGE_CHANGE_STARTED';
}

export interface IPageChangeFinishedAction {
  type: 'pagination/PAGE_CHANGE_FINISHED';
  data: IOffersData;
  paginationUrls: string[];
  commercialBreadcrumbs: ICommercialBreadcrumbs | null;
}

export const FILTERS_PAGINATION_PAGE_CHANGE_STARTED = 'pagination/PAGE_CHANGE_STARTED';
export const FILTERS_PAGINATION_PAGE_CHANGE_FINISHED = 'pagination/PAGE_CHANGE_FINISHED';
